import Vue from 'vue'

const { customAlphabet } = require('nanoid')
const alphabet = '0123456789abcdefghijklmnopqrstuvwxyz'
const nanoid = customAlphabet(alphabet, 8)

Vue.prototype.$nanoSub = nanoid
